module.exports = __webpack_public_path__ + "static/media/logobithappier.ebe4bcef.png";